<h2 mat-dialog-title>Idle Session Timeout</h2>

<mat-dialog-content>
  <p>Your session will time out in less than 2 minutes if you do not perform an action. Any unsaved information will be lost.</p>
</mat-dialog-content>

<mat-dialog-actions>
  <button id="change-button" mat-flat-button mat-dialog-close>OK</button>
</mat-dialog-actions>

